import Vue from "vue";
import { Component, Data, Prop, Lifecycle } from "vuety";
import { IProductGroupOptions, IProductGroupItem } from "../interfaces";
import { getGroupImageUrl, getGroupLinkUrl, getRoot } from "../root";
import { LoadingSpinner } from "../components/loadingspinner";

@Component({
	components: { "loading-spinner": LoadingSpinner },
})
export class BaseView extends Vue {
	@Data()
	public currentGroup: string;
	@Prop()
	public options: IProductGroupOptions;

	@Lifecycle()
	created() {
		this.currentGroup = getRoot().currentGroup;
		getRoot().$watch("currentGroup", () => {
			this.currentGroup = getRoot().currentGroup;
		});
		getRoot().loadData(this.options);
	}

	public getGroupLinkUrl(item: IProductGroupItem): string {
		return getGroupLinkUrl(this.options, item);
	}
	public getGroupImageUrl(item: IProductGroupItem): string {
		return getGroupImageUrl(this.options, item);
	}
	public itemClicked(e: MouseEvent, item: IProductGroupItem) {
		if (
			window.ProductGroupsPlugin.stayOnPage &&
			item.Children &&
			item.Children.length > 0 &&
			item.Items === 0
		) {
			getRoot().setCurrentGroup(this.options, item, true);
			e.preventDefault();
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/base.ts